module.exports = "../images/hunting-rifle@2x.jpg?v=776d217";